import React from 'react';

import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import { TGroupAdditionalInfoProps } from '@/shared/features/groups/components/group-select/group-additional-info/group-additional-info.types';

export const GroupAdditionalInfo: React.FC<TGroupAdditionalInfoProps> = ({
  group,
  maxLength = 32,
}) => {
  const fullPath = group.fullPaths?.slice(0, -1)?.join(' / ');

  if (!fullPath) {
    return null;
  }

  return (
    <TruncatedText
      variant="p10"
      color="textSecondary"
      text={fullPath}
      maxLength={maxLength}
      truncateFromBack
    />
  );
};
